"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ariaIsolate = _interopRequireDefault(require("../../utils/aria-isolate"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The cauldron toast notification component
 */
var Toast =
/*#__PURE__*/
function (_Component) {
  _inherits(Toast, _Component);

  function Toast(props) {
    var _this;

    _classCallCheck(this, Toast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toast).call(this, props));
    _this.state = {
      animationClass: props.show ? 'dqpl-fadein-setup' : 'dqpl-hidden',
      destroy: !props.show
    };
    _this.dismissToast = _this.dismissToast.bind(_assertThisInitialized(_this));
    _this.showToast = _this.showToast.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var destroy = this.state.destroy;
      var autoHide = this.props.autoHide;

      if (!destroy) {
        // Timeout because CSS display: none/block and opacity:
        // 0/1 properties cannot be toggled in the same tick
        // see: https://codepen.io/isnerms/pen/eyQaLP
        setTimeout(this.showToast);

        if (autoHide) {
          setTimeout(this.dismissToast, autoHide);
        }
      }
    } // TODO: getting rid of the destroy state all together would simplify this
    // (if props.show changes => do the show/hide stuff)

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var destroy = this.state.destroy;

      if (destroy && nextProps.show) {
        // update from hidden to show
        this.setState({
          animationClass: 'dqpl-fadein-setup'
        }, function () {
          // Timeout because CSS display: none/block and opacity:
          // 0/1 properties cannot be toggled in the same tick
          // see: https://codepen.io/isnerms/pen/eyQaLP
          setTimeout(_this2.showToast);
        });
      } else if (!destroy && !nextProps.show) {
        this.dismissToast();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          animationClass = _this$state.animationClass,
          destroy = _this$state.destroy;
      var _this$props = this.props,
          type = _this$props.type,
          children = _this$props.children,
          dismissText = _this$props.dismissText,
          toastRef = _this$props.toastRef;
      var scrim = type === 'action-needed' && !destroy ? _react["default"].createElement("div", {
        className: "dqpl-scrim-light dqpl-scrim-show dqpl-scrim-fade-in"
      }) : null;
      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        tabIndex: -1,
        className: "dqpl-toast dqpl-toast-".concat(_utils.typeMap[type].className, " ").concat(animationClass),
        ref: function ref(el) {
          toastRef(el);
          _this3.el = el;
        }
      }, _react["default"].createElement("div", {
        className: "dqpl-toast-message"
      }, _react["default"].createElement("div", {
        className: "fa ".concat(_utils.typeMap[type].icon),
        "aria-hidden": "true"
      }), _react["default"].createElement("span", null, children)), type !== 'action-needed' && _react["default"].createElement("button", {
        type: "button",
        className: 'dqpl-toast-dismiss fa fa-close',
        "aria-label": dismissText,
        onClick: this.dismissToast
      })), scrim);
    }
  }, {
    key: "dismissToast",
    value: function dismissToast() {
      var _this4 = this;

      if (!this.el) {
        return;
      }

      var _this$props2 = this.props,
          onDismiss = _this$props2.onDismiss,
          type = _this$props2.type;
      var isolator = this.state.isolator;
      this.setState({
        animationClass: 'dqpl-fadein-setup'
      }, function () {
        // Timeout because CSS display: none/block and opacity:
        // 0/1 properties cannot be toggled in the same tick
        // see: https://codepen.io/isnerms/pen/eyQaLP
        setTimeout(function () {
          if (type === 'action-needed') {
            (0, _utils.tabIndexHandler)(true, _this4.el);
            isolator.deactivate();
          }

          _this4.setState({
            destroy: true,
            animationClass: 'dqpl-hidden'
          }, onDismiss);
        });
      });
    }
  }, {
    key: "showToast",
    value: function showToast() {
      var _this5 = this;

      var type = this.props.type;
      this.setState({
        destroy: false,
        animationClass: 'dqpl-fadein-setup dqpl-fadein'
      }, function () {
        if (type === 'action-needed') {
          var isolator = new _ariaIsolate["default"](_this5.el);
          (0, _utils.tabIndexHandler)(false, _this5.el);

          _this5.setState({
            isolator: isolator
          });

          isolator.activate();
        }

        if (_this5.el) {
          // focus the toast
          _this5.el.focus();
        }
      });
    }
  }]);

  return Toast;
}(_react.Component);

exports["default"] = Toast;

_defineProperty(Toast, "propTypes", {
  // the ui to be added as the message of the toast
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]).isRequired,
  // "confirmation", "caution", or "action-needed"
  type: _propTypes["default"].string.isRequired,
  // function to be exectued when toast is dismissed
  onDismiss: _propTypes["default"].func,
  // if provided, should be a number in ms
  autoHide: _propTypes["default"].number,
  // text to be added as the aria-label of the "x" dismiss button (default: "Dismiss")
  dismissText: _propTypes["default"].string,
  // an optional ref function to get a handle on the toast element
  toastRef: _propTypes["default"].func,
  // whether or not to show the toast
  show: _propTypes["default"].bool
});

_defineProperty(Toast, "defaultProps", {
  dismissText: 'Dismiss',
  onDismiss: function onDismiss() {},
  toastRef: function toastRef() {},
  show: false
});